import React from 'react';
import styled from 'styled-components';
import Button from '../../components/ui/Button';
import { NextButtonProps } from '../../types';

const ButtonContainer = styled.div`
  margin-left: auto;
  display: flex;
  gap: 1.2rem;
  align-items: center;

    @media (max-width: 800px) {
        margin-right: auto;
    }
`;

const NextButton: React.FC<NextButtonProps> = ({ answer, index, numQuestions, onNextQuestion, onFinish }) => {
  if (answer === null) return null;

  if (index < numQuestions - 1) {
    return (
      <ButtonContainer>
        <Button $primary onClick={onNextQuestion}>
          Ďalšia otázka
        </Button>
      </ButtonContainer>
    );
  }

  if (index === numQuestions - 1) {
    return (
      <ButtonContainer>
        <Button $primary onClick={onFinish}>
          Výsledok
        </Button>
      </ButtonContainer>
    );
  }

  return null;
};

export default NextButton;
